"use client";

import { c as _c } from "react/compiler-runtime";
import { TableScrollContainerContext } from "@opensea/ui-kit";
import { useCallbackRef } from "@opensea/ui-kit/hooks";
import { SalesFeedTable } from "./SalesFeedTable";
export function SalesFeed() {
  const $ = _c(6);
  const [ref, setRef] = useCallbackRef();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SalesFeedTable />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== setRef) {
    t1 = <div className="scrollbar-hidden h-full overflow-auto [mask-image:linear-gradient(to_bottom,black_theme(spacing.6),black,transparent)]" ref={setRef}>{t0}</div>;
    $[1] = setRef;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== ref || $[4] !== t1) {
    t2 = <TableScrollContainerContext.Provider value={ref}>{t1}</TableScrollContainerContext.Provider>;
    $[3] = ref;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}